export default __webpack_public_path__ + "static/media/lightbulb.747223e6.jpg";